import { TAppVersion } from 'api/types';

interface IFaviconIcon {
  rel: string;
  type: string;
  href: string;
  sizes?: string;
}

/**
 * SaaS иконки из локальных файлов
 */
export const saasIcons: IFaviconIcon[] = [
  {
    rel: 'icon',
    type: 'image/svg+xml',
    href: '/icons/tender-10D.svg',
  },
  {
    rel: 'icon',
    type: 'image/x-icon',
    href: '/icons/tender-10D.ico',
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '16x16',
    href: '/icons/tender-10D-16.png',
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: '/icons/tender-10D-32.png',
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '48x48',
    href: '/icons/tender-10D-48.png',
  },
  {
    rel: 'apple-touch-icon',
    type: 'image/png',
    sizes: '180x180',
    href: '/icons/tender-10D-apple-touch.png',
  },
  {
    rel: 'shortcut icon',
    type: 'image/x-icon',
    href: '/icons/tender-10D.ico',
  },
];

/**
 * Самолет иконки для PWA (только основные размеры)
 */
const samoletPwaIcons: IFaviconIcon[] = [
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '192x192',
    href: '/samoletIcons/icon-192.png',
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '512x512',
    href: '/samoletIcons/icon-512.png',
  },
  {
    rel: 'apple-touch-icon',
    type: 'image/png',
    sizes: '180x180',
    href: '/samoletIcons/apple-touch-icon.png',
  },
];

/**
 * Получает Самолет иконки в зависимости от окружения
 */
export const getSamoletIcons = (stand: TAppVersion): IFaviconIcon[] => {
  const baseIcon =
    stand === TAppVersion.DEV
      ? 'favicon_dev'
      : stand === TAppVersion.STAGE
      ? 'favicon_stage'
      : 'favicon';

  return [
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: `/samoletIcons/${baseIcon}.svg`,
    },
    {
      rel: 'shortcut icon',
      type: 'image/x-icon',
      href: '/samoletIcons/favicon.ico',
    },
    ...samoletPwaIcons,
  ];
};

/**
 * Получает иконки для PWA в зависимости от типа приложения и окружения
 */
export const getPwaIcons = (stand: TAppVersion, isSaaS: boolean): IFaviconIcon[] => {
  if (isSaaS) {
    // Для SaaS используем только основные иконки для PWA
    return [
      {
        rel: 'icon',
        type: 'image/svg+xml',
        href: '/icons/tender-10D.svg',
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '192x192',
        href: '/icons/tender-10D-48.png', // Используем 48x48 как 192x192
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '512x512',
        href: '/icons/tender-10D-apple-touch.png', // Используем apple-touch как 512x512
      },
    ];
  }

  // Для Самолета используем локальные иконки
  return getSamoletIcons(stand);
};
